import { render } from "./ContentVideos.vue?vue&type=template&id=9f85a502"
import script from "./ContentVideos.vue?vue&type=script&lang=js"
export * from "./ContentVideos.vue?vue&type=script&lang=js"

import "./ContentVideos.vue?vue&type=style&index=0&id=9f85a502&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__